import * as React from "react";
import { Button } from "@/components/ui/button";
import { useUpdateBusinessReportMutation } from "../businessReports.api";
import { BusinessReport } from "@/modules/snapshots/businessReports.types";

interface BusinessReportTemplateCardDeleteProps {
  businessReport: BusinessReport;
  setIsEditOpen: (state: boolean) => void;
}

export const BusinessReportTemplateCardActions: React.FC<BusinessReportTemplateCardDeleteProps> = ({
  setIsEditOpen,
  businessReport,
}) => {
  const [updateBusinessReport, { isLoading }] = useUpdateBusinessReportMutation();

  const handleEdit = (event: React.SyntheticEvent) => {
    event.preventDefault();
    event.stopPropagation();
    setIsEditOpen(true);
  };

  const handleClick = async (event: React.SyntheticEvent) => {
    event.preventDefault();
    event.stopPropagation();

    await updateBusinessReport({
      data: {
        is_active: !businessReport.is_active,
      },
      id: businessReport.id,
    });
  };

  return (
    <div className="flex">
      <Button size="xs" className="mr-2 mt-5" variant="default" onClick={handleEdit}>
        Edit
      </Button>

      <Button
        size="xs"
        className="mt-5"
        variant={businessReport.is_active ? "destructive" : "secondary"}
        onClick={handleClick}
        disabled={isLoading}
      >
        {businessReport.is_active ? "Delete" : "Restore"}
      </Button>
    </div>
  );
};
